export function FacebookIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M13.5 22v-9h3l.5-3.5h-3.5V7.25c0-1 .28-1.75 1.75-1.75H17V2.38c-.78-.1-1.57-.14-2.36-.13-2.34 0-3.94 1.43-3.94 4.05v3.2H8V13h2.7v9h2.8Z" />
    </svg>
  );
}
